import { LyneButton } from "components/Lyne/LyneButton";
import { useSendToPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const SendToPanelFooter: React.FC = () => {
  const i18n = useTranslations();
  const { submitSendToPanel, isSubmitDisabled, closeSendToPanel, isSubmitted } = useSendToPanel();

  return (
    <>
      {!isSubmitted && (
        <>
          <LyneButton
            className="mr-2"
            onClick={(e) => {
              e.preventDefault();
              submitSendToPanel();
            }}
            disabled={isSubmitDisabled}
            text={i18n.SendtoPanel_Submit}
          />
          <LyneButton onClick={closeSendToPanel} text={i18n.Actions_Cancel} kind="secondary" />
        </>
      )}

      {isSubmitted && <LyneButton onClick={closeSendToPanel} text={i18n.Actions_Close} kind="primary" />}
    </>
  );
};
